
import React, {useEffect, useRef, useState} from "react";
import collegeManageStyles from "./college-oam.module.less";


import jiaoshimaBg from '../../static/image/college-oam/jiaoshima-bg.png';
import xueshengmaBg from '../../static/image/college-oam/xueshengma-bg.png';
import { sendHttpPostRequest } from "../../api/http-request";
import Cookies from 'js-cookie';

import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Tooltip,Progress,Tree,Drawer,Layout, message, Card, Col, Row, ConfigProvider, Pagination, Tabs, Input, Upload, Button, Popconfirm, Select, Menu, Table, Divider } from 'antd';

interface Props {
  match:any;
}


export const ProjectCollegeNumber: React.FC<Props> = (props) => {
  const {college_id} = props.match.params
    
    // const [collegeId, setCollegeId] =  useState(null as any);  // 当前用户是否为当前院校管理员
    const [collegeInfo, setCollegeInfo] =  useState([] as any);  // 当前院校信息
    const [isLogin, setIsLogin] = useState(false);//是否登录
    const [isCollegeManager, setIsCollegeManager] = useState(null as any);  // 当前用户是否为当前院校管理员
    const [studentCode, setStudentCode] = useState("");//机构学生码
    const [studentCodeTime, setStudentCodeTime] = useState("");//机构学生码有效期

    const [teacherCode, setTeacherCode] = useState("");//机构教师码
    const [teacherCodeTime, setTeacherCodeTime] = useState("");//机构教师码有效期


    useEffect(()=> {
        queryInstitution(college_id)
    },[])
    // 查询课程信息
    const queryInstitution = (collegeId: any) => {
        const sessionid = Cookies.get("sessionid");
        const queryData = {

            college_id: college_id,
            sessionid: sessionid,
            sid: sessionid,
        };
        sendHttpPostRequest(
            'college/api/manager_query_college_by_id/',
            queryData,
            institutionCallback
        )
    }


    // 查询机构接口回调
    const institutionCallback = (response: any) => {
        // console.log(response);
        message.destroy();
        if (response.code == -100) {
            // 未登录
            window.location.href = '/login?next=/college-oam';
        } else if (response.is_ok == true) {
            // 成功
            setCollegeInfo(response.college_info);
            setStudentCode(response.college_info.student_code);
            setStudentCodeTime(response.college_info.student_code_time);


            setTeacherCode(response.college_info.teacher_code);
            setTeacherCodeTime(response.college_info.teacher_code_time);

        } else if (response.code == -501) {
            // 权限不足
            window.location.href = '/login?next=/college-oam';
        } else {
            message.error(response.message);
        }
    }

    

    // 点了生成教师码
    const generateTeacherCodeCallback = (response: any) => {
        message.destroy();
        if (response.code == -100) {
            // 没登录
            console.log("没登录")
            //window.location.href = '/oam_login?next=oam_institution_list';
        } else if (response.code == -501) {
            // 没权限
            console.log("没权限")
            //window.location.href = '/oam_login?next=oam_institution_list';
        } else if (response.is_ok == true) {
            setTeacherCode(response?.teacher_code);
            setTeacherCodeTime(response?.teacher_code_time);
        } else {
            message.error(response.message);
        }
    }

    // 点了生成学生码
    const generateStudentCodeCallback = (response: any) => {
        message.destroy();
        if (response.code == -100) {
            // 没登录
            console.log("没登录")
            //window.location.href = '/oam_login?next=oam_institution_list';
        } else if (response.code == -501) {
            // 没权限
            console.log("没权限")
            //window.location.href = '/oam_login?next=oam_institution_list';
        } else if (response.is_ok == true) {
            setStudentCode(response?.student_code);
            setStudentCodeTime(response?.student_code_time);
        } else {
            message.error(response.message);
        }
    }

    // 点了生成教师码和学生码按钮
    const generateCode = (codeType: number) => {
        sendHttpPostRequest(
            'college/api/manager_update_college_code/',
            {
                sessionid: Cookies.get("sessionid"),
                college_id: college_id,
                code_type: codeType
            },
            codeType == 2? generateTeacherCodeCallback :generateStudentCodeCallback
        )
    }
    


    return <div className={collegeManageStyles.pageWrapper}>
        <div className={collegeManageStyles.collegeNumber}>
            <div id="teacher_code"  style={{backgroundImage:`url(${jiaoshimaBg})`,backgroundSize:'100% 100%'}}  className={collegeManageStyles.teacherCodeDiv}>
                <Divider orientation="left" className={collegeManageStyles.codeDivider}>教师码</Divider>

                <Row gutter={[12,12]} align='middle' justify="center" style={{marginTop:40}}>
                    <Col xs={24} sm={14} style={{textAlign:'center'}}>
                        <div className={collegeManageStyles.codeInputRow} style={{justifyContent:'center'}}>
                            <Input value={teacherCode} className={collegeManageStyles.codeInput} readOnly />
                            <CopyToClipboard text={"院校:" + collegeInfo.name + "，教师码：" + teacherCode + "，请前往个人中心认证身份：http://idatacoding.cn/user-center"}
                                         onCopy={() => {message.success("教师码已复制~")}}>
                                <Button size="small" className={collegeManageStyles.actionBtn}>复制</Button>
                            </CopyToClipboard>
                        </div>
                    </Col>

                    <Col xs={24} sm={10} style={{textAlign:'center'}}>
                        <Popconfirm placement="top" title={'教师码更新后，原有教师码将失效，确认吗？'} onConfirm={()=>{generateCode(2)}} okText="确认" cancelText="取消">
                            <Button size="small" className={collegeManageStyles.actionBtn}> {teacherCode == "" ? '生 成' : '重新生成'} </Button>
                        </Popconfirm>
                    </Col>
                </Row>


                <div className={collegeManageStyles.codeTip} style={{marginTop:40}}>
                    教师码使用超过一个月后，建议重新生成
                </div>
                <div className={collegeManageStyles.codeTip}>
                    上次生成时间:{teacherCodeTime}
                </div>

            </div>

            <div id="student_code"  style={{backgroundImage:`url(${xueshengmaBg})`,backgroundSize:'100% 100%',marginTop:30}}  className={collegeManageStyles.teacherCodeDiv}>
                <Divider orientation="left" className={collegeManageStyles.codeDivider}>学生码</Divider>

                <Row gutter={[12,12]} align='middle' justify="center" style={{marginTop:30}}>
                    <Col xs={24} sm={14} style={{textAlign:'center'}}>
                        <div className={collegeManageStyles.codeInputRow} style={{justifyContent:'center'}}>
                            <Input value={studentCode} className={collegeManageStyles.codeInput} readOnly />
                            <CopyToClipboard text={"院校:" + collegeInfo.name + ",学生码：" + studentCode + "，请前往个人中心认证身份：http://idatacourse.cn/user-center"}
                                         onCopy={() => {message.success("学生码已复制~")}}>
                                <Button size="small" className={collegeManageStyles.actionBtn}>复制</Button>
                            </CopyToClipboard>
                        </div>
                    </Col>

                    <Col xs={24} sm={10} style={{textAlign:'center'}}>
                        <Popconfirm placement="top" title={'学生码更新后，原有学生码将失效，确认吗？'} onConfirm={()=>{generateCode(1)}} okText="确认" cancelText="取消">
                            <Button size="small" className={collegeManageStyles.actionBtn}> {studentCode == "" ? '生 成' : '重新生成'} </Button>
                        </Popconfirm>
                    </Col>
                </Row>


                <div className={collegeManageStyles.codeTip} style={{marginTop:40}}>
                    学生码使用超过一个月后，建议重新生成
                </div>
                <div className={collegeManageStyles.codeTip}>
                    上次生成时间:{studentCodeTime}
                </div>



            </div>


            <div style={{color:'rgba(0,0,0,0.45)',textAlign:'left',marginBottom:10,marginTop:40}}>
                <div style={{fontSize:16,marginBottom:10,fontWeight:600,color:'#1d2129'}}> 院校码使用说明 </div>
                <ul>
                    <li>院校码用于认证平台用户的院校身份，可前往个人中心输入院校码认证身份。</li>
                    <li>院校码分为教师码和学生码两种。教师通过教师码获得本院校教师权限。学生通过学生码获得本院校学生权限。</li>
                    <li>请注意不要将教师码发送给学生，以免学生获得教师权限。</li>
                </ul>
            </div>

        </div>
    </div>
}


export default  ProjectCollegeNumber
